import React from 'react';
import DefaultLayout from '../../../layout/DefaultLayout';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import ProductColorTable from '../../../components/Catalog/productColor/ProductColorTable';

/**
 * 🎨 ItemColorsPage
 *
 * Página para administrar colores disponibles en productos.
 */
const ItemColorsPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ProductColorTable />
    </DefaultLayout>
  );
};

export default ItemColorsPage;
